import { Injectable, inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BootupService } from '../services/bootup/bootup.service';
import { PAGE } from 'src/app/routes';

@Injectable({
  providedIn: 'root',
})
export class UpdateRequiredGuard {
  private bootupService = inject(BootupService);
  private navController = inject(NavController);

  public async canActivate(): Promise<boolean> {
    if (!this.bootupService.updateRequired()) {
      return true;
    }
    this.navController.navigateRoot(`/${PAGE.UPDATE_REQUIRED}`);
    return false;
  }
}
